/**
 * Labstep
 *
 * @module core/DataGrid/Overlay/LoaderProgress
 * @desc DataGrid Loading Overlay component with progress bar
 */

import { Flex } from 'labstep-web/core/Flex';
import { Loader } from 'labstep-web/core/Loader';
import type React from 'react';
import { Progress } from 'semantic-ui-react';
import styles from './styles.module.scss';
import type { LoaderWithProgressProps } from './types';
export const LoaderWithProgress: React.FC<
  LoaderWithProgressProps
> = ({ value, total, hasFailed = false }) => {
  return (
    <Flex hAlignContent="center" spacing="between">
      Loaded {value} of {total}
      <Progress
        value={value.toString()}
        total={total.toString()}
        success={!hasFailed}
        error={hasFailed}
        className={styles.progressBar}
      />
      <Flex spacing="gap">
        <Loader size="tiny" active inline /> Loading{' '}
      </Flex>
    </Flex>
  );
};
